import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, of, Observable } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';

@Pipe({
  name: 'withLoading'
})
export class WithLoadingPipe implements PipeTransform {
  // tslint:disable-next-line:no-any
  transform(val): Observable<any> {
    return isObservable(val)
      ? val.pipe(
          map(value => ({ loading: false, value })),
          startWith({ loading: true }),
          catchError(error => of({ loading: false, error }))
        )
      : val;
  }
}
